import { render, staticRenderFns } from "./EventDateComponent.vue?vue&type=template&id=fa7a1c40"
import script from "./EventDateComponent.vue?vue&type=script&lang=js"
export * from "./EventDateComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports